// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1_JgK","fullScreen":"style_fullScreen__6aQSg","hidden":"style_hidden__G1ykp"};